import "./home.css";
import { QRCodeSVG } from "qrcode.react";
import phoneImg from "../../assets/home_image.png";
import appleIcon from "../../assets/apple.png";
import googleIcon from "../../assets/google.png";
import awardImg from "../../assets/icons/award.jpg";
import awardImg2025 from "../../assets/icons/award2025.jpg";
import qrCodeImgApple from "../../assets/qr-code-apple.png";
import qrCodeImgAndroid from "../../assets/qr-code-android.png";
import { Link } from "react-router-dom";
import bannerImg from "../../assets/banner.png";
import bannerMobileImg from "../../assets/banner_mobile.png";
import { Helmet } from "react-helmet";
import React from "react";
import { logEvent } from "../../analytics/analytics";

const IOS_URL = "https://apps.apple.com/de/app/simgo/id6751269737?l=en-GB";
const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.simgo&pcampaignid=web_share";

const Home = () => {
  return (
    <main className="home-page">
      <Link to="/shop" className="top-banner" aria-label="Buy eSIM">
        <picture>
          <source media="(max-width: 900px)" srcSet={bannerMobileImg} />
          <img src={bannerImg} alt="Buy eSIM" />
        </picture>
      </Link>
      <div className="home-container">
        {/* Left side */}
        <div className="download-section">
          <h1>Download Telviora</h1>
          <p>
            Manage your eSIMs quickly and easily with our mobile app. Choose your platform below or scan the QR code.
          </p>

          <div className="download-options">
            <div className="store-badges">
              <a
                href="https://apps.apple.com/en/app/telviora-global-travel-data/id6761282203"
                target="_blank"
                rel="noreferrer"
                className="store-badge"
                onClick={() => logEvent("app_download", "click_app_store", "App Store")}
              >
                <img src={appleIcon} alt="Apple" className="store-icon" />
                <div className="store-text">
                  <span className="small-text">Download on the</span>
                  <span className="big-text">App Store</span>
                </div>
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.telviora.esim"
                target="_blank"
                rel="noreferrer"
                className="store-badge"
                onClick={() => logEvent("app_download", "click_google_play", "Google Play")}
              >
                <img src={googleIcon} alt="Google Play" className="store-icon" />
                <div className="store-text">
                  <span className="small-text">Get it on</span>
                  <span className="big-text">Google Play</span>
                </div>
              </a>
            </div>

            {/* <div className="qr-section">
              <div className="qr-box">
                <QRCodeSVG value={IOS_URL} size={100} />
                <div className="qr-label">App Store</div>
              </div>

              <div className="qr-box">
                <QRCodeSVG value={ANDROID_URL} size={100} />
                <div className="qr-label">Google Play</div>
              </div>
            </div> */}
            <div className="qr-section">
              <div className="qr-box">
                <img src={qrCodeImgApple} alt="App Store QR" className="qr-image" />
                <div className="qr-label">App Store</div>
              </div>

              <div className="qr-box">
                <img src={qrCodeImgAndroid} alt="Google Play QR" className="qr-image" />
                <div className="qr-label">Google Play</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right side */}
        <div className="phone-section">
          <img src={phoneImg} alt="Phone Preview" />
        </div>
      </div>

      {/* Award banner */}
      {/* Awards banner */}
      <section className="about__awards" aria-label="Awards">
        <div className="awards__grid">
          {/* Award 2024 */}
          {/* <div className="award__inner">
            <div className="award__media">
              <img src={awardImg} alt="Antonio Meucci Global Telco Awards 2024" loading="lazy" />
            </div>

            <div className="award__content">
              <h3 className="award__title">
                Recognized as the <br />
                “Most Innovative Roaming Solution”.
              </h3>

              <p className="award__lead">Honored at the Antonio Meucci Global Telco Awards 2024.</p>

              <a
                className="award__link1"
                href="https://globtel.biz/uncategorized/success-on-antonio-meucci-awards-2024/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Read full story
              </a>
            </div>
          </div> */}

          {/* Award 2025 */}
          {/* <div className="award__inner award__inner--right">
            <div className="award__media">
              <img
                src={awardImg2025}
                alt="Antonio Meucci Global Telco Awards 2025"
                loading="lazy"
              />
            </div>

            <div className="award__content award__content--right">
              <h3 className="award__title">
                Four Awards – including 1st place in
                <br />
                "Best eSIM Provider."
              </h3>

              <p className="award__lead">
                Globtel Triumphs at the Antonio Meucci Global Telco Awards 2025.
              </p>

              <a
                className="award__link1"
                href="https://globtel.biz/uncategorized/antonio-meucci-2025-press-release/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Read full story
              </a>
            </div>
          </div> */}
        </div>
      </section>
    </main>
  );
};

export default Home;
